@if (useClientFilter) {
  <div class="searchFilterContainer">
    <input
      class="searchInput"
      [placeholder]="getSearchPlaceholder()"
      #filterListInput
      type="text"
      [(ngModel)]="searchString"
      (ngModelChange)="onSearchFilterInputChange($event)">
      @if (!shouldShowRemoveFilter()) {
        <i class="fa fa-search searchIcon"></i>
      }
      @if (shouldShowRemoveFilter()) {
        <i class="fa fa-remove searchIcon" (click)="removeSearchFilter()"></i>
      }
      <rask-label class="searchResultLabel" size="3"><span>{{getSearchResultText()}}</span></rask-label>
    </div>
  }
  <div [ngClass]="{'tableFixHead': fixedHeader, 'virtual-scroll': virtualScroll}">
    @if (!virtualScroll && showTable) {
      <table>
        <ng-container *ngTemplateOutlet="tableContent"></ng-container>
      </table>
    }

    @if (virtualScroll && showTable && virtualScrollType === 'window') {
      <cdk-virtual-scroll-viewport scrollWindow
        [itemSize]="virtualScrollItemHeight">
        <table>
          @if (showHeader) {
            <thead>
              <tr>
                @if (rowSelectable) {
                  <th
                    [style.top]="inverseOfCdkScrollTranslation"
                    [style.width]="checkboxWidth">
                    <rask-checkbox
                      class="list-checkbox"
                      [(ngModel)]="selectAll"
                      (change)="selectAllChanged($event)">
                    </rask-checkbox>
                  </th>
                }
                @for (column of columns; track column) {
                  <th
                    id="th_{{column.header}}"
                    (click)="setSorting(column)"
                    [style.top]="inverseOfCdkScrollTranslation"
                    [ngClass]="{'sortable': column.sortable}"
                    [style.width]="column.width"
                    [style.min-width]="column.minWidth">
                    @if (!column.headerTemplate) {
                      {{column.header}}
                    }
                    @if (column.headerTemplate) {
                      <ng-container *ngTemplateOutlet="column.headerTemplate"></ng-container>
                    }
                    @if (isSortActive(column) && isSortReverse(column) === false) {
                      <span
                      class="far fa-arrow-up"></span>
                    }
                    @if (isSortActive(column) && isSortReverse(column)) {
                      <span class="far fa-arrow-down"></span>
                    }
                  </th>
                }
              </tr>
            </thead>
          }
          <tbody>
            <ng-container
              *cdkVirtualFor="let row of dataSorted; trackBy: trackById; let rowidx = index; let last = last; templateCacheSize: 80;">
              <ng-container *ngTemplateOutlet="tableRow; context: { row: row, idx: rowidx, last: last}">
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    }

    @if (virtualScroll && showTable && virtualScrollType === 'panel') {
      <cdk-virtual-scroll-viewport
        [ngStyle]="{'height': viewportHeight}"
        [itemSize]="virtualScrollItemHeight">
        <table>
          @if (showHeader) {
            <thead>
              <tr>
                @if (rowSelectable) {
                  <th
                    [style.top]="inverseOfCdkScrollTranslation"
                    [style.width]="checkboxWidth">
                    <rask-checkbox
                      class="list-checkbox"
                      [(ngModel)]="selectAll"
                      (change)="selectAllChanged($event)">
                    </rask-checkbox>
                  </th>
                }
                @for (column of columns; track column) {
                  <th
                    id="th_{{column.header}}"
                    (click)="setSorting(column)"
                    [style.top]="inverseOfCdkScrollTranslation"
                    [ngClass]="{'sortable': column.sortable}"
                    [style.width]="column.width"
                    [style.min-width]="column.minWidth">
                    @if (!column.headerTemplate) {
                      {{column.header}}
                    }
                    @if (column.headerTemplate) {
                      <ng-container *ngTemplateOutlet="column.headerTemplate"></ng-container>
                    }
                    @if (isSortActive(column) && isSortReverse(column) === false) {
                      <span
                      class="far fa-arrow-up"></span>
                    }
                    @if (isSortActive(column) && isSortReverse(column)) {
                      <span class="far fa-arrow-down"></span>
                    }
                  </th>
                }
              </tr>
            </thead>
          }
          <tbody>
            <ng-container
              *cdkVirtualFor="let row of dataSorted; trackBy: trackById; let rowidx = index; let last = last; templateCacheSize: 80;">
              <ng-container *ngTemplateOutlet="tableRow; context: { row: row, idx: rowidx, last: last}">
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    }
  </div>

  <ng-template #tableRow let-row="row" let-rowidx="idx" let-last="last">
    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
    @if (row.headerRow != null) {
      <tr class="innerHeader">
        <td [attr.colspan]="columns.length" class="header">
          {{ row.headerRow }}
        </td>
      </tr>
    }
    <tr [id]="generateId(rowidx)"
      [ngClass]="{'selected': isSelected(rowidx, last), 'thinLine': fixedHeader, 'locked': row.isLocked }"
      [className]="row.cssClass || ''">
      @if (rowSelectable) {
        <td
          [style.top]="inverseOfCdkScrollTranslation"
          [style.width]="checkboxWidth">
          <rask-checkbox class="list-checkbox" [(ngModel)]="row.selected"
          (change)="selectRowChanged($event)"></rask-checkbox>
        </td>
      }
      @for (column of columns; track column) {
        <td class="svea-text"
          [ngClass]="{'ellipsis': column.nowrap, 'centered': column.centered}"
          [attr.colid]="column.field">
          @if (column.template) {
            <ng-container
              *ngTemplateOutlet="column.template; context: {row: row, $implicit: row[column.field]}">
            </ng-container>
          }
          @if (column.tooltip) {
            <ng-container
              *ngTemplateOutlet="rawValueWithTooltip; context: {$implicit: row[column.field]}">
            </ng-container>
          }
          @if (!column.template && !column.tooltip) {
            <ng-container *ngTemplateOutlet="rawValue; context: {$implicit: row[column.field]}">{{
            row[column.field] }}</ng-container>
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template #tableContent>
    @if (showHeader) {
      <thead>
        <tr>
          @if (rowSelectable) {
            <th
              [style.top]="inverseOfCdkScrollTranslation"
              [style.width]="checkboxWidth">
              <rask-checkbox
                class="list-checkbox"
                [(ngModel)]="selectAll"
                (change)="selectAllChanged($event)">
              </rask-checkbox>
            </th>
          }
          @for (column of columns; track column) {
            <th id="th_{{column.header}}" (click)="setSorting(column)"
              [ngClass]="{'sortable': column.sortable}" [style.width]="column.width"
              [style.min-width]="column.minWidth">
              @if (!column.headerTemplate) {
                {{column.header}}
              }
              @if (column.headerTemplate) {
                <ng-container *ngTemplateOutlet="column.headerTemplate"></ng-container>
              }
              @if (isSortActive(column) && isSortReverse(column) === false) {
                <span class="far fa-arrow-up"></span>
              }
              @if (isSortActive(column) && isSortReverse(column)) {
                <span class="far fa-arrow-down"></span>
              }
            </th>
          }
        </tr>
      </thead>
    }
    <tbody>
      @for (row of dataSorted; track trackById(rowidx, row); let rowidx = $index; let last = $last) {
        <ng-container *ngTemplateOutlet="tableRow; context: { row: row, idx: rowidx, last: last}">
        </ng-container>
      }

      @for (row of customRows; track trackById(rowidx, row); let rowidx = $index; let last = $last) {
        <tr [id]="generateRowId(rowidx)"
          [ngClass]="{'selected': isSelected(rowidx, last)}">
          @if (rowSelectable) {
            <td
              [style.top]="inverseOfCdkScrollTranslation"
              [style.width]="checkboxWidth">
              <rask-checkbox class="list-checkbox"></rask-checkbox>
            </td>
          }
          @for (column of row.columns; track column) {
            <td class="svea-text"
              [ngClass]="{'ellipsis': column.nowrap, 'centered': column.centered}" [attr.colid]="column.field">
              <ng-container
                *ngTemplateOutlet="column.template; context: {row: row, $implicit: row[column.field]}">
              </ng-container>
            </td>
          }
        </tr>
      }
    </tbody>
  </ng-template>

  <ng-template #rawValue let-value>
    {{value}}
  </ng-template>

  <ng-template #rawValueWithTooltip let-value>
    <span data-bs-toggle="tooltip" data-placement="top" title="{{value}}">
      {{value}}
    </span>
  </ng-template>